var React = require('react');

function PurpleCircleInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"3","cy":"3","fill":"#b070fd","r":"3"}));
}

PurpleCircleInline.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","viewBox":"0 0 6 6"};

module.exports = PurpleCircleInline;

PurpleCircleInline.default = PurpleCircleInline;
